import {BackendUserDetail} from 'components/Backend/User/Detail';

export default BackendUserDetail;
